import React, { useEffect } from 'react';
import Video from 'twilio-video';

export function unSubscribe(
  videoTracks: (Video.RemoteTrack | Video.LocalTrack)[],
  videoRef: React.MutableRefObject<HTMLVideoElement | null>,
  audioTracks: (Video.RemoteTrack | Video.LocalTrack)[],
  audioRef: React.MutableRefObject<HTMLAudioElement | null>,
) {
  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack && videoTrack.kind !== 'data') {
      // @ts-ignore
      videoTrack.attach(videoRef.current);
      return () => {
        // @ts-ignore
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack && audioTrack.kind !== 'data') {
      // @ts-ignore
      audioTrack.attach(audioRef.current);
      return () => {
        // @ts-ignore
        audioTrack.detach();
      };
    }
  }, [audioTracks]);
}
